import type { JobOfferV2WithCompanyId } from "@/domains/job-offer/types";
import type { ReceivedProposalItem } from "../types/proposals";

/** Build a job shape compatible with JobOfferBadges from proposal data. */
export function proposalToJobForBadges(
  proposal: ReceivedProposalItem,
): JobOfferV2WithCompanyId {
  const jo = proposal.jobOffer;
  const daily =
    jo.payment_type === "daily" &&
    jo.daily_rate_min != null &&
    jo.daily_rate_max != null
      ? {
          daily_rate_min: jo.daily_rate_min,
          daily_rate_max: jo.daily_rate_max,
        }
      : {};
  return {
    id: jo.id,
    title: jo.title,
    payment_type: jo.payment_type,
    job_category: jo.job_category,
    job_subcategory: jo.job_subcategory,
    remote_policy: jo.remote_policy,
    location: jo.location ?? undefined,
    skills: jo.skills ?? [],
    budget: proposal.budget ?? jo.budget ?? undefined,
    currency: jo.currency ?? "EUR",
    ...daily,
    company_id: jo.company,
    is_active: jo.is_active ?? true,
    created_at: proposal.created_at,
    updated_at: proposal.updated_at,
    description: jo.description,
    payment_status: jo.payment_status,
  } satisfies JobOfferV2WithCompanyId;
}
